define('collections/distributor_manager',['require','collections/base','models/distributor_manager'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/distributor_manager");

    return BaseCollection.extend({
        model: Model,
        url: 'distributor-managers.json'
    });
});

